import * as Styles from "./styles";
import { Modal, Button } from "antd";

export interface OkPopupProps {
  visible: boolean;
  isCloseOkPopup: () => void;
  isCancel: () => void;
  errorMessage: string
}

export default function OkPopup({
  visible,
  isCloseOkPopup,
  isCancel,
  errorMessage
}: OkPopupProps) {
  const showAlreadyPickedHeader = errorMessage?.includes(
    "Required number of items already picked"
  );

  return (
    <Styles.Container>
      <Modal
        wrapClassName="operator"
        title={showAlreadyPickedHeader ? "Already Picked Order" : undefined}
        open={visible}
        onOk={isCloseOkPopup}
        onCancel={isCancel}
        closable={true}
        footer={[
          <Button key="submit" type="primary" onClick={isCloseOkPopup}>
            Okay
          </Button>
        ]}
      >
        <Styles.Content>
          {errorMessage || "Already Picked Order"}
        </Styles.Content>
      </Modal>
    </Styles.Container>
  );
}
